export default __webpack_public_path__ + "static/media/like.af5bffd8.svg";